import { userConstants } from '../constants'
import { ClientService, StorageService } from '../services'

/**
 * Authenticates an user into application
 * @param {object} user The application user
 */
const login = (user) => {
	return {
		type: userConstants.LOGIN,
		user,
	}
}

const setAccessToken = (accessToken) => {
	return {
		type: userConstants.SET_ACCESS_TOKEN,
		payload: accessToken,
	}
}

/**
 * Unauthenticates the current user into application
 */
const logout = () => {
	StorageService.authentication.user.remove()
	return {
		type: userConstants.LOGOUT,
	}
}

const updatePlan = () => async (dispatch) => {
	ClientService.getSubscription()
		.then(({ data: plan, success }) => {
			return dispatch({
				type: userConstants.UPDATE_PLAN,
				payload: success ? plan : null,
			})
		})
		.catch(() => dispatch({ type: userConstants.UPDATE_PLAN, payload: null }))
}

export const userActions = { login, logout, updatePlan, setAccessToken }
